//@ts-ignore
import { ComponentHelper } from '@Helper/Infra';
import { CircularProgress, Grid, IconButton } from '@mui/material';

import { useAppDispatch, useAppSelector } from '@Store/hooks';
import { getDroppedOrSelectedFiles } from 'html5-file-selector';
import React, { useEffect, useState } from 'react';
import Dropzone, { IInputProps, ILayoutProps } from 'react-dropzone-uploader';
import { toast } from 'react-toastify';

import { Icons } from '../../../assets/SvgIcons';
import { CoreServices } from '../../../helper/CoreServices';
import { ICTaskAttachment } from '../../../helper/Interfaces';
import classes from './CustomDropZone.module.css';

//@ts-ignore
interface CustomDropZoneProps {
  taskAttachments: ICTaskAttachment[];
  setattachments: (attachment: ICTaskAttachment[]) => void;
  deleteAttachments: (attachment: ICTaskAttachment) => void;
  taskId: string;
  disabled?: boolean;
}

const CustomDropZone = (props: CustomDropZoneProps) => {
  const maxSize = 50000000;
  const {
    taskAttachments,
    deleteAttachments,
    taskId,
    disabled,
    setattachments,
  } = props;
  const coreServices: CoreServices = new CoreServices();
  const [initialFiles, setInitialFiles] = React.useState<ICTaskAttachment[]>(
    []
  );

  const [fileLoading, setFileLoading] = useState<boolean>(false);
  const [fileDeleteLoading, setFileDeleteLoading] = useState<boolean>(false);
  const [fileDelete, setFileDelete] = useState<ICTaskAttachment>();
  const componentHelper = new ComponentHelper();
  const dispatch = useAppDispatch();

  useEffect(() => {
    setInitialFiles(taskAttachments);
  }, [taskAttachments]);

  const Input = ({
    accept,
    onFiles,
    files,
    getFilesFromEvent,
  }: IInputProps) => {
    const text = files.length > 0 ? 'Add more files' : 'Choose files';

    return (
      <label className={classes.inputLabel}>
        {fileLoading ? <CircularProgress size={20} color="inherit" /> : <></>}{' '}
        <h5>Drop files here</h5>
        <p>or click here to open your file prompt menu</p>
        <input
          style={{ display: 'none' }}
          type="file"
          accept={text}
          multiple
          disabled={fileLoading || disabled}
          onChange={async e => {
            setFileLoading(true);
            const chosenFiles = await getFilesFromEvent(e);
            const files = await coreServices.createTaskAttachment(
              taskId,
              chosenFiles
            );
            console.log('files', files);
            if (files.length && files.includes(undefined)) {
              setFileLoading(false);
              toast('File Upload Fail');
            } else {
              setInitialFiles(old => [...old, ...files]);
              setattachments([...taskAttachments, ...files]);
              setFileLoading(false);
              onFiles(chosenFiles as File[]);
            }
          }}
        />
      </label>
    );
  };

  const getFilesFromEvent = async (e: any) => {
    const chosenFiles = await getDroppedOrSelectedFiles(e);
    return chosenFiles.map((f: any) => f.fileObject);
  };

  const fileType = (file: string) => {
    if (
      file === 'xml' ||
      file === 'png' ||
      file === 'jpeg' ||
      file === 'jpg' ||
      file === 'svg'
    ) {
      return (
        <div className={classes.documentItem}>
          <Icons.Png />
        </div>
      );
    }
    if (file === 'pdf') {
      return (
        <div className={classes.documentItem}>
          <Icons.Pdf />
        </div>
      );
    }
    if (file === 'xls' || file === 'xlsx' || file === 'csv') {
      return (
        <div className={classes.documentItem}>
          <Icons.Xls />
        </div>
      );
    }
    if (file === 'doc' || file === 'docx') {
      return (
        <div className={classes.documentItem}>
          <Icons.Doc />
        </div>
      );
    }
    if (file === 'pptx' || file === 'pot' || file === 'pps' || file === 'ppa') {
      return (
        <div className={classes.documentItem}>
          <Icons.Pptx />
        </div>
      );
    }
    return (
      <div className={[classes.documentItem, classes.question].join(' ')}>
        <Icons.QuestionMark />
      </div>
    );
  };

  const handleDelete = async (attachment: ICTaskAttachment) => {
    setFileDeleteLoading(true);
    setFileDelete(attachment);
    const res = await coreServices.deleteTaskAttachment(attachment.id);

    setFileDeleteLoading(false);
    setFileDelete(undefined);

    if (res) {
      setInitialFiles(old => [
        ...old.filter(item => item.id !== attachment.id),
      ]);
      deleteAttachments(attachment);
      toast(
        <div style={{ display: 'flex' }}>
          <div style={{ padding: 10 }}>
            <Icons.CheckIcon />
          </div>
          <div style={{ padding: 10 }}>
            <div
              style={{
                color: '#46426E',
                fontWeight: '700',
                fontFamily: 'Inter',
              }}
            >
              Success
            </div>
            <div
              style={{
                color: '#1C174D',
                fontWeight: '500',
                fontFamily: 'Inter',
              }}
            >
              Successfully deleted.
            </div>
          </div>
        </div>
      );
    } else {
      toast(
        <div style={{ display: 'flex' }}>
          <div style={{ padding: 10 }}>
            <Icons.ErrorIcon />
          </div>
          <div style={{ padding: 10 }}>
            <div
              style={{
                color: '#46426E',
                fontWeight: '700',
                fontFamily: 'Inter',
              }}
            >
              Error
            </div>
            <div
              style={{
                color: '#1C174D',
                fontWeight: '500',
                fontFamily: 'Inter',
              }}
            >
              Error on deleting attachment
            </div>
          </div>
        </div>
      );
    }
  };

  const openAttachment = async (attachment: ICTaskAttachment) => {
    const res = await coreServices.retrieveTaskAttachment(attachment.id);
    //console.log(res.contentBase64);
    let type = '';
    const file = attachment.document.name?.split('.').pop() || '';
    console.log('file', file);
    console.log('file res', res);

    if (res.contentBase64) {
      if (
        file === 'xml' ||
        file === 'png' ||
        file === 'jpeg' ||
        file === 'jpg' ||
        file === 'svg'
      ) {
        type = 'data:application/png;base64,';
      } else if (file === 'pdf') {
        type = 'data:application/pdf;base64,';
      } else if (file === 'xls' || file === 'xlsx' || file === 'csv') {
        type =
          'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,';
      } else if (file === 'doc' || file === 'docx' || file === 'rtf') {
        type =
          'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,';
      } else if (
        file === 'ppt' ||
        file === 'pot' ||
        file === 'pps' ||
        file === 'ppa'
      ) {
        type = 'data:application/vnd.ms-powerpoint;base64,';
      } else if (file === 'pptx') {
        type =
          'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,';
      } else if (file === 'txt') {
        type = 'data:text/plain;base64,';
      }

      if (type !== '') {
        let fetchDataModified = `${type}${res.contentBase64}`;
        let a = document.createElement('a');
        a.href = fetchDataModified;
        a.download = attachment.document.name;
        a.click();
      }
    }
  };

  const Preview = (attachmet: ICTaskAttachment) => {
    const src = attachmet.document.name?.split('.').pop() || '';
    return (
      <div className={classes.previewBox} key={attachmet.id}>
        <span
          className={classes.previewBoxName}
          onClick={() => openAttachment(attachmet)}
        >
          {fileType(src)}
          <div>{attachmet.document.name} </div>
        </span>
        <IconButton
          disabled={fileDelete ? true : false}
          type="submit"
          aria-label="search"
          onClick={() => handleDelete(attachmet)}
        >
          {fileDeleteLoading && fileDelete && fileDelete.id === attachmet.id ? (
            <CircularProgress size={20} color="inherit" />
          ) : (
            <Icons.Delete />
          )}
        </IconButton>
      </div>
    );
  };

  const fileDrop = async (e: any) => {
    e.preventDefault();
    setFileLoading(true);
    const chosenFiles = await getFilesFromEvent(e);
    const files = await coreServices.createTaskAttachment(taskId, chosenFiles);
    setInitialFiles(old => [...old, ...files]);
    setattachments([...taskAttachments, ...files]);
    setFileLoading(false);
  };

  const Layout = ({
    input,
    previews,
    submitButton,
    dropzoneProps,
    files,
    extra: { maxFiles },
  }: ILayoutProps) => {
    return (
      <div {...dropzoneProps} onDrop={fileDrop}>
        <div>{files.length < maxFiles && input}</div>

        {/*{files.length > 0 && submitButton}*/}
        <div style={{ marginTop: 15 }}>
          {<Grid container>{initialFiles?.map(item => Preview(item))}</Grid>}
          {initialFiles
            .map(i => parseInt(i.document.size))
            .reduce((acc: number, curr: number) => acc + curr, 0) > maxSize && (
            <div
              style={{
                fontStyle: 'italic',
                color: 'red',
                fontSize: '1.4vh',
              }}
            >
              Maximum File Size is 50 MB
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Dropzone
        LayoutComponent={Layout}
        InputComponent={Input}
        maxSizeBytes={maxSize}
        //PreviewComponent={Preview}
        autoUpload={true}
        getFilesFromEvent={getFilesFromEvent}
        //initialFiles={initialFiles}
        multiple
      />
    </>
  );
};

export default CustomDropZone;
